itsoftApp.createModule('copyPromoCode', ['popups'], function () {
    let module = this;

    const inputMaskInit = function () {
        const copyCode = document.getElementById('promo-code'); // input type hidden
        const copyBtn = document.getElementById('promo-button');

        if (copyBtn && copyCode) {
            copyBtn.addEventListener('click', event => {
                copyCode.select();
                document.execCommand("copy");
            });
        }
    };

    inputMaskInit();
    module.callback = inputMaskInit;
});
